import { Box, Typography } from "@mui/material";
import type { SalvosBillingPlanSumCheck } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosBillingPlanSumCheck.ts";
import { formatMoneyWithCurrency } from "src/utils/numberUtils.ts";

export interface SalvosBillingPlanSumDifferenceContentProps {
	check: SalvosBillingPlanSumCheck;
}

export function SalvosBillingPlanSumDifferenceContent({ check }: SalvosBillingPlanSumDifferenceContentProps) {
	function formatSum(sum: number | null | undefined) {
		return formatMoneyWithCurrency(sum ?? 0, check.currencyCode);
	}

	return (
		<Box
			sx={{
				marginY: 1,
				marginX: 2,
				display: "flex",
				flexDirection: "column",
				gap: 1,
			}}
		>
			<Typography>
				Tilaus: {check.customerOrderId}
				{check.orderReference ? ` / ${check.orderReference}` : ""}
			</Typography>
			<Typography>Myyntitilausrivien verollinen summa: {formatSum(check.orderLinesTotalWithVat)}</Typography>
			<Typography>Laskutussuunnitelman verollinen summa: {formatSum(check.billingPlanTotalWithVat)}</Typography>
			<Typography>Erotus (myyntitilausrivit − laskutussuunnitelma): {formatSum(check.difference)}</Typography>
			<Typography>Korjaa summat vastaamaan toisiaan ja yritä uudelleen.</Typography>
		</Box>
	);
}
